// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback[data-v-7d37ab0d] {\n  width: 100%;\n}\n.feedback__title-wrapper[data-v-7d37ab0d] {\n  padding: 7px 30px;\n  background-color: #2b255c;\n  color: #fff;\n}\n.feedback__title[data-v-7d37ab0d] {\n  margin-bottom: 10px;\n  font-weight: bold;\n  font-size: 18px;\n}\n\n", ""]);
// Exports
module.exports = exports;
